import { createSlice } from '@reduxjs/toolkit';
import { fetchControlPerm } from '../action/controlPermAction';
const initialState = { controlPerm: [], isLoader: false, loaded: false };
export const controlPermSlice = createSlice({
    initialState,
    name: 'controlPerm',
    reducers: {},
    extraReducers: {
        [fetchControlPerm.pending.type]: (state) => {
            state.isLoader = true;
        },
        [fetchControlPerm.fulfilled.type]: (state, action) => {
            state.controlPerm = action.payload || [];
            state.isLoader = false;
            state.loaded = true;
        },
        [fetchControlPerm.rejected.type]: (state) => {
            state.isLoader = false;
            state.loaded = true;
        }
    }
});
export default controlPermSlice.reducer;
